export const GOOGLE_OPTIMIZE_EXPERIMENTS = {
  local: "",
  development: "SgamgGm4TViiqPAhlfq6Lg",
  staging: "SgamgGm4TViiqPAhlfq6Lg",
  production: "sBW5QDUeRY2uS3h3ndMmeg",
};
